<template>
  <div class="saving-screen fixed" v-if="isLoading">
    <span>Sayfa hazırlanıyor, lütfen bekleyin....</span>
  </div>
  <div class="saving-screen fixed" v-if="isCreating">
    <span>PDFler hazırlanıyor, lütfen bekleyin....</span>
  </div>

  <filter-bar
    ref="filterBarRef"
    :show-first-row="true"
    :show-filter-button="true"
    filter-button-text="Filtre"
    :is-loading="isLoading || errorImages.length > 0"
    :show-dynamic-properties="true"
    @filter="onExportFilter"
    @property-change="onDynamicPropertyChange"
  >
    <template #first-row>
      <r-input v-model="realUrl" label="Sitede kullanılacak Url" width="30%" />
      <r-btn
        bgcolor="#ff1155"
        @click="copyHtml"
        :disabled="errorImages.length > 0"
      >
        HTML Kopyala
      </r-btn>
      <r-select
        v-if="store.state.usertype === 0 || store.state.usertype === 1"
        v-model="questPart"
        label="Soru Çeşidi"
        :data="questParts"
        txt="txt"
        val="val"
        width="15%"
        @change="getQuests"
      />
      <r-select
        v-if="store.state.usertype === 2"
        v-model="catId"
        label="Kategoriler"
        :data="catList?.data || []"
        txt="title"
        val="id"
        width="15%"
        @change="GetCategoryQuestions"
        style="color: rgb(17, 17, 17)"
      >
        <template v-slot:itemtxt="{ data }">
          {{ data.id + "_" + data.title }}
        </template>
      </r-select>
      <r-select
        v-model="branchId"
        label="Branş"
        :data="branchList?.data || []"
        txt="title"
        val="id"
        width="15%"
        style="color: rgb(17, 17, 17)"
        @change="onBranchChange"
      />
      <r-select
        v-model="subCategoryId"
        label="Alt Kategori"
        :data="subCategoryList?.data || []"
        txt="title"
        val="id"
        width="15%"
        style="color: rgb(17, 17, 17)"
        :disabled="!branchId"
      />
    </template>

    <template #second-row>
      <r-select
        v-model="noteCategoryId"
        label="Kitap Türü"
        :data="notesCatsList?.data || []"
        txt="title"
        val="id"
        width="18%"
        @change="onNoteCategoryChange"
        style="color: rgb(17, 17, 17)"
      />
      <r-select
        v-model="noteId"
        label="Kitap"
        :data="noteList?.data || noteList?.Data || []"
        txt="name"
        val="id"
        width="22%"
        style="color: rgb(17, 17, 17)"
      />
      <r-input v-model="startQuestion" label="PDF Başlangıç" width="10%" />
      <r-input v-model="endQuestion" label="PDF Bitiş" width="10%" />
    </template>

    <template #actions>
      <r-btn
        bgcolor="#ff9800"
        class="r-ml-8"
        @click="clearDynamicFilters"
        :disabled="isLoading || errorImages.length > 0"
      >
        Dinamik Filtreyi Temizle
      </r-btn>
      <r-btn
        bgcolor="#aa6600"
        @click="createPDF"
        :disabled="errorImages.length > 0"
      >
        PDF Oluştur
      </r-btn>
      <r-btn
        bgcolor="#0a7"
        @click="createPDFSequential"
        :disabled="errorImages.length > 0"
        style="margin-left:8px;"
      >
        PDF Oluştur (Sıralı)
      </r-btn>
      <r-btn
        bgcolor="#aa6600"
        @click="createSeperatePDF"
        :disabled="errorImages.length > 0"
        style="margin-left:8px;"
      >
        Parçalı PDF Oluştur
      </r-btn>
      <r-btn
        bgcolor="#6c757d"
        @click="openPdfColorSettings"
        style="margin-left:8px;"
      >
        PDF Ayarları
      </r-btn>
    </template>
  </filter-bar>
  <r-flex class="r-mb-16 page-header-C">
    <h3>Referanslar</h3>
  </r-flex>
  <r-flex>
    <h4 v-if="errorImages.length > 0" class="txt-error">
      PDF sayfalardaki resimlerin tamamı yüklenemedi. Lütfen kontrol edip tekrar
      export etmeyi deneyin. Etkilenen Sayfalar: {{ errorImages }}
    </h4>
  </r-flex>
  <r-flex v-if="loaded">
    <r-flex flx="7" align="center" class="all-reference-pages" v-if="loaded">
      <template v-for="(questionRef, m) in realList" :key="m">
        <references-pages
          :pagedata="questionRef.references"
          :qtype="questionType(questionRef.question)"
          :question="questionRef.question"
          :imagelist="imagesList['list' + questionRef.question.examNumber]"
          v-model:imagesloaded="pageImagesLoaded"
        />
      </template>
    </r-flex>
    <div
      class="export-question-C"
      style="width: 100%; display: flex; flex-direction: column"
    >
      <template v-for="(quest, i) in firstList.data" :key="i">
        <div style="width: 100%; margin-bottom: 16px">
          <div style="display: flex" v-if="quest.question.isCase">
            <strong>{{ quest.question.examNumber }}.</strong>
            <div style="display: flex" class="r-mb-8">
              <div v-html="quest.question.case"></div>
            </div>
          </div>

          <!-- Soru kökü doluysa, soru kökünü göster -->
          <div v-if="quest.question.detailModifield && quest.question.detailModifield.trim()">
            <div style="display: flex">
              <strong>{{ quest.question.examNumber }}.</strong>
              <div v-html="quest.question.detailModifield"></div>
              <br />
            </div>
          </div>
          <!-- Normal durum: soru ve şıklar göster -->
          <template v-else>
          <div style="display: flex">
            <strong v-if="!quest.question.isCase">
              {{ quest.question.examNumber }}.
            </strong>
            <div v-html="quest.question.detail"></div>
            <br />
          </div>
          <div style="display:flex;flex-direction:column;padding-bottom:12px;">
            <template v-for="(choice, j) in quest.question.choiceList" :key="j">
              <div
                :style="{
                  display: 'flex',
                  color:
                    store.state.choices[j] === quest.question.answer
                      ? getPdfColor('correctAnswer')
                      : ''
                }"
              >
                <p style="width: auto; width: 20px">
                  {{ store.state.choices[j] }})
                </p>
                <div v-html="choice"></div>
              </div>
            </template>
          </div>
          </template>
          <div
            style="display:flex;flex-direction:column;"
            v-if="quest.references.length > 0"
          >
            <template v-for="(ref, k) in quest.references" :key="k">
              <div style="display: flex">
                <span :style="{ color: getPdfColor('referenceLabel') }">
                  Referans: &nbsp;
                </span>
                <span :style="{ color: getPdfColor('referenceTitle') }">
                  {{ ref.title }}&nbsp;
                </span>
                <a
                  :style="{ color: getPdfColor('referenceLink') }"
                  target="_blank"
                  :href="DownloadPdfUrl(quest, ref)"
                >
                  Referansları görüntülemek için tıklayın
                </a>
              </div>
            </template>
          </div>
          <r-btn
            @click="createPartPDF(i)"
            class="r-mt-8 r-mb-32"
            :disabled="errorImages.length > 0"
          >
            PDF Oluştur
          </r-btn>
        </div>
      </template>
    </div>
  </r-flex>
</template>
<script>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import ReferencesPages from "../Referanslar/ReferencesPages";
import FilterBar from "@/components/FilterBar/FilterBar.vue";
import { makeUrl } from "@/mix/global.js";
import { getPdfColor, getPdfColors } from "@/utils/pdfColors.js";
export default {
  components: {
    ReferencesPages,
    FilterBar
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const listData = ref({});
    const notesCatsList = ref({});
    const noteCategoryId = ref(null);
    const noteList = ref({});
    const noteId = ref(null);
    const loaded = ref(false);
    const noReference = ref(false);
    const imagesList = ref({});
    const realUrl = ref("");
    const isCreating = ref(false);
    const isLoading = ref(false);
    const firstList = ref({});
    const listcnt = ref(0);
    const questPart = ref(0);
    const pageImagesLoaded = ref(true);
    const startQuestion = ref(1);
    const endQuestion = ref(100);
    const errorImages = ref([]);
    const imagesLoaded = ref(false);
    const pageImages = ref([]);
    const pdfImages = ref([]);
    const catId = ref(null);
    const catList = ref({});
    const branchId = ref(null);
    const branchList = ref({});
    const subCategoryId = ref(null);
    const subCategoryList = ref({});
    const questionCount = ref(0);
    const contentEl = ref(null);
    const questParts = ref([
      { txt: "Temel Bilimler", val: 1 },
      { txt: "Klinik Bilimler", val: 2 }
    ]);
    const dynamicPropertyFilters = ref({});
    const filterBarRef = ref(null);
    const referenceImagesLoaded = () => {
      pageImages.value.forEach(img => {
        img.addEventListener("error", function() {
          if (
            errorImages.value.indexOf(img.getAttribute("data-imgquestion")) < 0
          )
            errorImages.value.push(img.getAttribute("data-imgquestion"));
        });
      });
    };
    const realList = computed(() => {
      return listData.value.data;
    });
    const questionType = q => {
      if (store.state.usertype === 0) {
        if (parseInt(q.examNumber) <= store.state.tustemelq)
          return "Temel Bilimler";
        else return "Klinik Bilimler";
      } else if (store.state.usertype === 1) {
        if (parseInt(q.examNumber) <= store.state.dustemelq)
          return "Temel Bilimler";
        else return "Klinik Bilimler";
      } else if (store.state.usertype === 2) {
        return q.categoryName;
      }
    };
    const minQuest = computed(() => {
      if (store.state.usertype === 0 && parseInt(questPart.value) === 0)
        return 1;
      else if (store.state.usertype === 0 && parseInt(questPart.value) === 1)
        return store.state.tustemelq + 1;
      else if (store.state.usertype === 1 && parseInt(questPart.value) === 0)
        return 1;
      else if (store.state.usertype === 1 && parseInt(questPart.value) === 1)
        return store.state.dustemelq + 1;
      else if (store.state.usertype === 2) return 1;
    });
    const maxQuest = computed(() => {
      if (store.state.usertype === 0 && parseInt(questPart.value) === 0)
        return store.state.tustemelq;
      else if (store.state.usertype === 0 && parseInt(questPart.value) === 1)
        return store.state.tustotalq;
      else if (store.state.usertype === 1 && parseInt(questPart.value) === 0)
        return store.state.dustemelq;
      else if (store.state.usertype === 1 && parseInt(questPart.value) === 1)
        return store.state.dustotalq;
      else if (store.state.usertype === 2) return questionCount.value;
    });

    const newList = (list, quest) => {
      list.sort((a, b) => {
        return a.priority - b.priority;
      });
      imagesList.value["list" + quest.examNumber] = [];
      var newArr = [];
      var listKeys = [];
      var ind = 0;
      if (list.length > 0) {
        list.forEach(itm => {
          if (listKeys.indexOf(itm.noteCategoryName) === -1) {
            listKeys.push(itm.noteCategoryName);
            let notcat = notesCatsList.value.data.filter(v => {
              return v.id === itm.noteCategoryId;
            })[0];
            newArr.push({
              id: ind,
              title: itm.noteCategoryName,
              pagetitle: notcat.title,
              pagedesc: notcat.description,
              data: [itm]
            });
            imagesList.value["list" + quest.examNumber].push([]);
            ind++;
          } else {
            newArr[listKeys.indexOf(itm.noteCategoryName)].data.push(itm);
          }
        });
        newArr.forEach((itm, i) => {
          var subKeys = [];
          var indi = 0;
          itm.data1 = [];
          itm.data.forEach(dr => {
            if (subKeys.indexOf(dr.userId) === -1) {
              subKeys.push(dr.userId);
              itm.data1.push({
                id: indi,
                title: dr.username,
                userid: dr.userId,
                data: [dr]
              });

              indi++;
            } else {
              itm.data1[subKeys.indexOf(dr.userId)].data.push(dr);
            }
            dr.pid = i;
            delete itm.data;
          });
          itm.data1.forEach((dat, m) => {
            dat.data.forEach((pag, n) => {
              if (pag.pages.length > 0) {
                pag.pages[0].detail.forEach((drw, o) => {
                  if (drw.isImg) {
                    drw.iid = i;
                    drw.tid = m;
                    drw.pid = n;
                    drw.kid = o;
                    drw.url =
                      "https://referans.tusem.com.tr/referansnotlari/" +
                      store.state.workFolder +
                      "/edited_ref_img_" +
                      store.state.usertype +
                      "/" +
                      quest.categoryId +
                      "/" +
                      pag.lessonNoteId +
                      "/" +
                      drw.fileName +
                      ".jpg";
                    imagesList.value["list" + quest.examNumber][i].push(drw);
                  }
                });
              }
            });
          });
        });
      } else {
        imagesList.value["list" + quest.examNumber].push([]);
      }
      imagesList.value = Object.assign({}, imagesList.value);
      list.splice(0, list.length, ...newArr);
      listcnt.value++;
    };

    const createPDF = () => {
      isCreating.value = true;
      setTimeout(() => {
        const doc = new jsPDF("p", "px", [1000, 1415]);
        var els = document.getElementsByClassName("pdf-screen-W-save");
        console.log("[PDF_EXPORT] createPDF - total candidate pages", {
          totalEls: els.length
        });

        var newels = [];
        els.forEach(el => {
          if (
            parseInt(el.getAttribute("data-question")) >=
              parseInt(startQuestion.value) &&
            parseInt(el.getAttribute("data-question")) <=
              parseInt(endQuestion.value)
          )
            newels.push(el);
        });
        console.log("[PDF_EXPORT] createPDF - total candidate pages", {
          totalEls: els.length,
          filteredEls: newels.length,
          startQuestion: startQuestion.value,
          endQuestion: endQuestion.value
        });
        var cnt = 0;
        var imgCnt = 0;
        var imgC = {};
        var intC = {};
        newels.forEach(async (el, i) => {
          const qn = el.getAttribute("data-question");
          console.log("[PDF_EXPORT] createPDF - capturing element", {
            index: i,
            question: qn
          });
          html2canvas(el, {
            scale: 2.535,
            scrollX: 0,
            scrollY: 0,
            width: 700,
            useCORS: true,
            allowTaint: false
          }).then(function(canvas) {
            const imgData = canvas.toDataURL("image/jpeg");
            imgC["im" + i] = imgData;
            console.log("[PDF_EXPORT] createPDF - canvas ready (FULL)", {
              index: i,
              question: qn,
              imgLength: imgData.length,
              imgFull: imgData
            });
            intC["i" + i] = setInterval(() => {
              if (imgC["im" + i] !== "") {
                clearInterval(intC["i" + i]);
                cnt++;
              }
            }, 500);
          });
        });

        var saveImgInt = setInterval(() => {
          if (cnt === newels.length) {
            clearInterval(saveImgInt);
            console.log(
              "[PDF_EXPORT] createPDF - all images ready, adding to doc",
              {
                total: newels.length
              }
            );
            for (let e = 0; e < newels.length; e++) {
              console.log("[PDF_EXPORT] createPDF - addImage", {
                index: e,
                question: newels[e].getAttribute("data-question"),
                hasData: !!imgC["im" + e]
              });
              doc.addImage(imgC["im" + e], "JPEG", 0, 0);
              imgCnt++;
              if (imgCnt !== newels.length) doc.addPage();
              delete imgC["im" + e];
            }
          }
        }, 1000);

        var saveInt = setInterval(() => {
          if (imgCnt === newels.length) {
            clearInterval(saveInt);
            var docname =
              store.state.workFolder +
              "_" +
              store.state.usertype +
              "_" +
              startQuestion.value +
              "_" +
              endQuestion.value +
              ".pdf";
            if (store.state.usertype === 2)
              docname =
                store.state.workFolder +
                "_" +
                store.state.usertype +
                "_" +
                catId.value +
                "_" +
                startQuestion.value +
                "_" +
                endQuestion.value +
                ".pdf";

            console.log("[PDF_EXPORT] createPDF - saving document", {
              docname,
              totalPages: imgCnt
            });
            doc.save(docname);
            isCreating.value = false;
          }
        }, 1000);
      }, 50);
    };

    const createPDFSequential = async () => {
      isCreating.value = true;
      try {
        const doc = new jsPDF("p", "px", [1000, 1415]);
        const elsAll = document.getElementsByClassName("pdf-screen-W-save");
        const els = Array.from(elsAll).filter(el => {
          const qn = parseInt(el.getAttribute("data-question"));
          return (
            qn >= parseInt(startQuestion.value) &&
            qn <= parseInt(endQuestion.value)
          );
        });
        console.log("[PDF_EXPORT] createPDFSequential - filtered elements", {
          totalEls: elsAll.length,
          filteredEls: els.length,
          startQuestion: startQuestion.value,
          endQuestion: endQuestion.value
        });
        for (let i = 0; i < els.length; i++) {
          const el = els[i];
          const qn = el.getAttribute("data-question");
          console.log("[PDF_EXPORT] createPDFSequential - capturing element", {
            index: i,
            question: qn
          });
          const canvas = await html2canvas(el, {
            scale: 1.9,
            scrollX: 0,
            scrollY: 0,
            width: 700,
            useCORS: true,
            allowTaint: false
          });
          const img = canvas.toDataURL("image/jpeg", 0.75);
          console.log("[PDF_EXPORT] createPDFSequential - image ready (FULL)", {
            index: i,
            question: qn,
            imgLength: img.length,
            imgFull: img
          });
          doc.addImage(img, "JPEG", 0, 0, 1000, 1415);
          console.log("[PDF_EXPORT] createPDFSequential - addImage done", {
            index: i,
            question: qn
          });
          if (i !== els.length - 1) doc.addPage();
        }
        let docname =
          store.state.workFolder +
          "_" +
          store.state.usertype +
          "_" +
          startQuestion.value +
          "_" +
          endQuestion.value +
          ".pdf";
        if (store.state.usertype === 2)
          docname =
            store.state.workFolder +
            "_" +
            store.state.usertype +
            "_" +
            catId.value +
            "_" +
            startQuestion.value +
            "_" +
            endQuestion.value +
            ".pdf";
        console.log("[PDF_EXPORT] createPDFSequential - saving document", {
          docname,
          totalPages: els.length
        });
        doc.save(docname);
      } catch (e) {
        console.error("createPDFSequential error", e);
      } finally {
        isCreating.value = false;
      }
    };

    const createSeperatePDF = () => {
      isCreating.value = true;
      setTimeout(() => {
        var noarr = 0;
        var imgaC = {};
        var intaC = {};
        var nocnt = 0;
        var docnoarr = {};
        listData.value.data.forEach(async arr => {
          if (
            parseInt(arr.question.examNumber) >=
              parseInt(startQuestion.value) &&
            parseInt(arr.question.examNumber) <= parseInt(endQuestion.value)
          ) {
            if (arr.references.length > 0) {
              arr.references.forEach((pag, j) => {
                const doc = new jsPDF("p", "px", [1000, 1415]);
                var els = document.getElementsByClassName(
                  "sep-page-save-" + arr.question.examNumber + "-" + j
                );
                var newels = [];
                els.forEach(el => {
                  if (
                    parseInt(el.getAttribute("data-question")) >=
                      parseInt(startQuestion.value) &&
                    parseInt(el.getAttribute("data-question")) <=
                      parseInt(endQuestion.value)
                  )
                    newels.push(el);
                });
                var cnt = 0;
                var imgCnt = 0;
                var imgC = {};
                var intC = {};
                newels.forEach(async (el, i) => {
                  await html2canvas(el, {
                    scale: 2.535,
                    scrollX: 0,
                    scrollY: 0,
                    width: 700,
                    useCORS: true,
                    allowTaint: false
                  }).then(function(canvas) {
                    imgC["im" + i] = canvas.toDataURL("image/jpeg");
                    intC["i" + i] = setInterval(() => {
                      if (imgC["im" + i] !== "") {
                        clearInterval(intC["i" + i]);
                        cnt++;
                      }
                    }, 500);
                  });
                });

                var saveImgInt = setInterval(() => {
                  if (cnt === newels.length) {
                    clearInterval(saveImgInt);
                    for (let e = 0; e < newels.length; e++) {
                      doc.addImage(imgC["im" + e], "JPEG", 0, 0);
                      imgCnt++;
                      if (imgCnt !== newels.length) doc.addPage();
                      delete imgC["im" + e];
                    }
                  }
                }, 1000);

                var int = setInterval(() => {
                  if (imgCnt === newels.length) {
                    clearInterval(int);
                    var docname =
                      store.state.workFolder +
                      "_" +
                      store.state.usertype +
                      "_" +
                      arr.question.examNumber +
                      "_" +
                      makeUrl(pag.title) +
                      ".pdf";
                    if (store.state.usertype === 2)
                      docname =
                        store.state.workFolder +
                        "_" +
                        store.state.usertype +
                        "_" +
                        catId.value +
                        "_" +
                        arr.question.examNumber +
                        "_" +
                        makeUrl(pag.title) +
                        ".pdf";

                    doc.save(docname);
                    isCreating.value = false;
                  }
                }, 1000);
              });
            } else {
              noarr++;
              var el = document.getElementsByClassName(
                "sep-page-save-" + arr.question.examNumber + "-0"
              )[0];
              docnoarr["doc-" + arr.question.examNumber] = new jsPDF(
                "p",
                "px",
                [1000, 1415]
              );
              await html2canvas(el, {
                scale: 2.535,
                scrollX: 0,
                scrollY: 0,
                width: 700,
                useCORS: true,
                allowTaint: false
              }).then(function(canvas) {
                imgaC["im" + arr.question.examNumber] = canvas.toDataURL(
                  "image/jpeg"
                );
                intaC["i" + arr.question.examNumber] = setInterval(() => {
                  if (imgaC["im" + arr.question.examNumber] !== "") {
                    clearInterval(intaC["i" + arr.question.examNumber]);
                    delete intaC["i" + arr.question.examNumber];
                    docnoarr["doc-" + arr.question.examNumber].addImage(
                      imgaC["im" + arr.question.examNumber],
                      "JPEG",
                      0,
                      0
                    );
                    nocnt++;
                    delete imgaC["im" + arr.question.examNumber];
                  }
                }, 500);
                var inta = setInterval(() => {
                  if (nocnt === noarr) {
                    clearInterval(inta);

                    Object.keys(docnoarr).forEach(k => {
                      let examNum = k.split("-");
                      var docname =
                        store.state.workFolder +
                        "_" +
                        store.state.usertype +
                        "_" +
                        examNum[1] +
                        ".pdf";
                      if (store.state.usertype === 2)
                        docname =
                          store.state.workFolder +
                          "_" +
                          store.state.usertype +
                          "_" +
                          catId.value +
                          "_" +
                          examNum[1] +
                          ".pdf";
                      docnoarr[k].save(docname);
                      delete docnoarr[k];
                    });
                    isCreating.value = false;
                  }
                }, 1000);
              });
            }
          }
        });
      }, 50);
    };

    const DownloadPdfUrl = (q, r) => {
      if (store.state.usertype === 2) {
        return (
          realUrl.value +
          "/" +
          store.state.workFolder +
          "_" +
          store.state.usertype +
          "_" +
          catId.value +
          "_" +
          q.question.examNumber +
          "_" +
          makeUrl(r.title) +
          ".pdf"
        );
      } else {
        return (
          realUrl.value +
          "/" +
          store.state.workFolder +
          "_" +
          store.state.usertype +
          "_" +
          q.question.examNumber +
          "_" +
          makeUrl(r.title) +
          ".pdf"
        );
      }
    };
    const createPartPDF = async x => {
      isCreating.value = true;
      setTimeout(() => {
        if (listData.value.data[x].references.length > 0) {
          listData.value.data[x].references.forEach((pag, j) => {
            const doc = new jsPDF("p", "px", [1000, 1415]);
            var els = document.getElementsByClassName(
              "sep-page-save-" +
                listData.value.data[x].question.examNumber +
                "-" +
                j
            );
            var cnt = 0;
            var imgCnt = 0;
            var imgC = {};
            var intC = {};
            els.forEach(async (el, i) => {
              await html2canvas(el, {
                scale: 2.535,
                scrollX: 0,
                scrollY: 0,
                width: 700,
                useCORS: true,
                allowTaint: false
              }).then(function(canvas) {
                imgC["im" + i] = canvas.toDataURL("image/jpeg");
                intC["i" + i] = setInterval(() => {
                  if (imgC["im" + i] !== "") {
                    clearInterval(intC["i" + i]);
                    cnt++;
                  }
                }, 500);
              });
            });
            var saveImgInt = setInterval(() => {
              if (cnt === els.length) {
                clearInterval(saveImgInt);
                for (let e = 0; e < els.length; e++) {
                  doc.addImage(imgC["im" + e], "JPEG", 0, 0);
                  imgCnt++;
                  if (imgCnt !== els.length) doc.addPage();
                  delete imgC["im" + e];
                }
              }
            }, 1000);
            var int = setInterval(() => {
              if (imgCnt === els.length) {
                clearInterval(int);
                var docname =
                  store.state.workFolder +
                  "_" +
                  store.state.usertype +
                  "_" +
                  listData.value.data[x].question.examNumber +
                  "_" +
                  makeUrl(pag.title) +
                  ".pdf";
                if (store.state.usertype === 2)
                  docname =
                    store.state.workFolder +
                    "_" +
                    store.state.usertype +
                    "_" +
                    catId.value +
                    "_" +
                    listData.value.data[x].question.examNumber +
                    "_" +
                    makeUrl(pag.title) +
                    ".pdf";
                doc.save(docname);
                isCreating.value = false;
              }
            }, 1000);
          });
        } else {
          var rdy = false;
          const doc = new jsPDF("p", "px", [1000, 1415]);
          var el = document.getElementsByClassName(
            "sep-page-save-" + listData.value.data[x].question.examNumber + "-0"
          )[0];
          html2canvas(el, {
            scale: 2.535,
            scrollX: 0,
            scrollY: 0,
            width: 700
          }).then(function(canvas) {
            var img = canvas.toDataURL("image/jpeg");
            var imgint = setInterval(() => {
              if (img !== "") {
                clearInterval(imgint);
                doc.addImage(img, "JPEG", 0, 0);
                rdy = true;
              }
            }, 500);
            var inta = setInterval(() => {
              if (rdy) {
                clearInterval(inta);
                var docname =
                  store.state.workFolder +
                  "_" +
                  store.state.usertype +
                  "_" +
                  listData.value.data[x].question.examNumber +
                  ".pdf";
                if (store.state.usertype === 2)
                  docname =
                    store.state.workFolder +
                    "_" +
                    store.state.usertype +
                    "_" +
                    catId.value +
                    "_" +
                    listData.value.data[x].question.examNumber +
                    ".pdf";

                doc.save(docname);
                isCreating.value = false;
              }
            }, 1000);
          });
        }
      }, 50);
    };
    const getQuests = async e => {
      if (!e || e.val === undefined) return;
      questPart.value = e.val;
      // Tüm alt kategorileri al (pid=0)
      const result = await getCatList(0);
      if (result && result.data && Array.isArray(result.data)) {
        // JavaScript'te filtrele: 1=Temel Bilimler (ParentId=1), 2=Klinik Bilimler (ParentId=2)
        const filteredData = result.data.filter(item => {
          // Hem parentId hem ParentId kontrolü yap (camelCase ve PascalCase)
          const parentId =
            item.parentId !== undefined ? item.parentId : item.ParentId;
          if (e.val === 1) {
            // Temel Bilimler
            return parentId === 1;
          } else if (e.val === 2) {
            // Klinik Bilimler
            return parentId === 2;
          }
          return false;
        });
        branchList.value = { data: filteredData };
        branchId.value = null; // Seçimi kullanıcıya bırak
        subCategoryId.value = null; // Alt kategoriyi sıfırla
        subCategoryList.value = { data: [] }; // Alt kategori listesini temizle
      } else {
        branchList.value = { data: [] };
        branchId.value = null;
        subCategoryId.value = null;
        subCategoryList.value = { data: [] };
      }
    };
    const SetQuestionValue = () => {
      if (store.state.usertype === 0) {
        if (questPart.value === 0) {
          startQuestion.value = 1;
          endQuestion.value = 100;
        } else {
          startQuestion.value = 101;
          endQuestion.value = 200;
        }
      }
      if (store.state.usertype === 1) {
        if (questPart.value === 0) {
          startQuestion.value = 1;
          endQuestion.value = 40;
        } else {
          startQuestion.value = 41;
          endQuestion.value = 100;
        }
      }
      if (store.state.usertype === 2) {
        startQuestion.value = 1;
        endQuestion.value = questionCount.value;
      }
    };
    const getList = async (categoryId, branchIdParam, subCategoryIdParam, noteIdParam) => {
      // Kullanıcının girdiği değerleri kullan, yoksa computed değerleri kullan
      const minParsed =
        startQuestion.value && startQuestion.value.toString().trim() !== ""
          ? parseInt(startQuestion.value)
          : null;
      const maxParsed =
        endQuestion.value && endQuestion.value.toString().trim() !== ""
          ? parseInt(endQuestion.value)
          : null;
      const minVal =
        minParsed !== null && !isNaN(minParsed) ? minParsed : minQuest.value;
      const maxVal =
        maxParsed !== null && !isNaN(maxParsed) ? maxParsed : maxQuest.value;
      let params = {
        max: maxVal,
        min: minVal,
        workmonth: store.state.workMonth,
        workyear: store.state.workYear,
        isImg: true
      };

      // Dinamik property filtreleri: { [propDefId]: number[] } → düz listeye çevir
      const dynamicValues = dynamicPropertyFilters.value || {};
      const allValueIds = Object.values(dynamicValues)
        .reduce((acc, arr) => {
          if (Array.isArray(arr)) {
            return acc.concat(arr);
          }
          return acc;
        }, [])
        .filter((v, idx, arr) => arr.indexOf(v) === idx);

      // Dinamik property filtreleri
      if (allValueIds.length > 0) {
        params.dynamicPropertyValueIds = allValueIds.join(",");
      }
      
      let api = "references/getallreferences";
      if (store.state.usertype === 2 && categoryId !== undefined) {
        params.categoryId = categoryId;
        api = "references/getallreferencesbycategory";
      } else {
        // Soru çeşidi filtresi (sadece GetAllReferences için)
        if (questPart.value != null && questPart.value !== 0) {
          params.questPart = questPart.value;
        }
      }
      
      // Öncelik sırası: alt kategori > branş
      // Alt kategori seçilmişse, sadece alt kategoriyi gönder (daha spesifik)
      // Alt kategori seçilmemişse ama branş seçilmişse, branşı gönder
      if (subCategoryIdParam) {
        params.subCategoryId = subCategoryIdParam;
      } else if (branchIdParam) {
        params.branchId = branchIdParam;
      }
      
      // Kitap türü ve kitap filtreleri
      // Öncelik: noteId > noteCategoryId
      // noteId varsa sadece onu gönder, yoksa noteCategoryId gönder
      if (noteIdParam != null && noteIdParam !== undefined && noteIdParam !== 0) {
        params.noteId = noteIdParam;
      } else if (noteCategoryId.value) {
        params.noteCategoryId = noteCategoryId.value;
      }
      let list = await store.dispatch("getDatas", {
        api: api,
        params: params
      });
      var noref = 0;
      firstList.value = list;
      if (list && list.data && Array.isArray(list.data)) {
        list.data.forEach(itm => {
          if (itm.references.length === 0) noref++;
        });
        if (list.data.length === noref) noReference.value = true;
      }
      return list;
    };
    const GetCategoryQuestions = async d => {
      catId.value = d.id;
      questionCount.value = await getQuestionCount();
    };

    const onDynamicPropertyChange = payload => {
      // { propertyDefinitionId, selectedValues }
      if (!payload || payload.propertyDefinitionId == null) return;
      dynamicPropertyFilters.value = {
        ...dynamicPropertyFilters.value,
        [payload.propertyDefinitionId]: payload.selectedValues || []
      };
    };

    const clearDynamicFilters = () => {
      dynamicPropertyFilters.value = {};
      // FilterBar içindeki dinamik checkbox'ları da sıfırla
      if (
        filterBarRef.value &&
        typeof filterBarRef.value.resetDynamicProperties === "function"
      ) {
        filterBarRef.value.resetDynamicProperties();
      }
      // Listeyi dinamik filtreler olmadan yeniden yükle
      applyFilter();
    };

    const onExportFilter = async payload => {
      if (payload && payload.propertyValues) {
        dynamicPropertyFilters.value = payload.propertyValues;
      } else {
        dynamicPropertyFilters.value = {};
      }
      await applyFilter();
    };

    const applyFilter = async () => {
      loaded.value = false;
      imagesList.value = Object.assign({});
      isLoading.value = true;
      if (store.state.usertype === 0 || store.state.usertype === 1) {
        listData.value = await getList(undefined, branchId.value, subCategoryId.value, noteId.value);
      } else if (store.state.usertype === 2) {
        if (!catId.value) {
          catList.value = await getCatList();
          catId.value = catList.value.data?.[0]?.id;
        }
        questionCount.value = await getQuestionCount();
        listData.value = await getList(
          catId.value,
          branchId.value,
          subCategoryId.value,
          noteId.value
        );
      }
      if (
        firstList.value &&
        firstList.value.data &&
        Array.isArray(firstList.value.data)
      ) {
        firstList.value.data.sort((a, b) => {
          return (
            parseInt(a.question.examNumber) - parseInt(b.question.examNumber)
          );
        });
      }
      setTimeout(() => {
        listForPdf();
      }, 100);
    };
    const getCatList = async (pid = 0) => {
      let list = await store.dispatch("getDatas", {
        api: "categories/getsubcategories",
        params: { pid }
      });

      return list;
    };
    const getNoteCatsList = async () => {
      let list = await store.dispatch("getDatas", {
        api: "notes/getnotecategories"
      });
      return list;
    };
    const getNotesByCategory = async (categoryId, notCategoryId) => {
      let list = await store.dispatch("getDatas", {
        api: "notes/getnotesbycategoryandnotcatid",
        params: {
          categoryId: categoryId,
          isActive: true,
          notCategoryId: notCategoryId
        }
      });
      return list;
    };
    // Branş değiştiğinde alt kategori listesini güncelle
    const onBranchChange = async e => {
      if (!e || e.id === undefined) return;
      branchId.value = e.id;

      // Seçilen branşın alt kategorilerini getir
      if (e.id) {
        const result = await store.dispatch("getDatas", {
          api: "categories/getsubcategories",
          params: { pid: e.id }
        });
        if (result && result.data && Array.isArray(result.data)) {
          subCategoryList.value = { data: result.data };
          subCategoryId.value = null; // Seçimi kullanıcıya bırak
        } else {
          subCategoryList.value = { data: [] };
          subCategoryId.value = null;
        }
      } else {
        subCategoryList.value = { data: [] };
        subCategoryId.value = null;
      }
    };

    const onNoteCategoryChange = async e => {
      if (!e || e.id === undefined) return;
      noteCategoryId.value = e.id;
      // Kitap türü değiştiğinde noteId'yi sıfırla (sadece kitap türüne göre filtreleme yapılacak)
      noteId.value = null;
      // branchId (CategoryId) ve noteCategoryId (NoteCategoryId) ikisini de gönder
      if (branchId.value && noteCategoryId.value) {
        const result = await getNotesByCategory(
          branchId.value,
          noteCategoryId.value
        );
        console.log("API Response:", result);
        // result.data veya result.Data kontrolü yap
        const dataArray =
          result?.data || result?.Data || (Array.isArray(result) ? result : []);
        if (dataArray && Array.isArray(dataArray) && dataArray.length > 0) {
          noteList.value = { data: dataArray };
          // İlk kitabı otomatik seçme, kullanıcı seçsin
          // noteId.value = dataArray[0].id || null;
        } else {
          noteList.value = { data: [] };
        }
      } else {
        noteList.value = { data: [] };
      }
      // Kitap türü değiştiğinde filtreyi uygula
      await applyFilter();
    };
    const getQuestionCount = async () => {
      let list = await store.dispatch("getDatas", {
        api: "categories/getquestioncount",
        params: {
          categoryid: catId.value
        }
      });
      return list.data;
    };
    const copyHtml = () => {
      var el = document.querySelector(".export-question-C");
      var cln = el.cloneNode(true);
      var div = document.createElement("div");
      div.appendChild(cln);
      var btns = div.getElementsByTagName("button");
      while (btns[0]) btns[0].parentNode.removeChild(btns[0]);
      div.innerHTML = div.innerHTML.replace(/<!--.*?-->/g, "");
      var txta = document.createElement("textarea");
      txta.value = div.innerHTML;
      txta.style.top = "0";
      txta.style.left = "100%";
      txta.style.position = "fixed";
      txta.style.opacity = "0";
      txta.style.width = "0";
      txta.style.height = "0";
      document.body.appendChild(txta);
      txta.focus();
      txta.select();
      document.execCommand("copy");
      document.body.removeChild(txta);
      cln.remove();
      div.remove();
    };
    const openPdfColorSettings = () => {
      router.push({ name: "pdfrenkayarlari" });
    };
    const listForPdf = () => {
      listData.value.data.sort((a, b) => {
        return (
          parseInt(a.question.examNumber) - parseInt(b.question.examNumber)
        );
      });
      listcnt.value = 0;
      var imgcnt = 0;
      pdfImages.value = [];
      listData.value.data.forEach(quest => {
        newList(quest.references, quest.question);
      });
      var int = setInterval(() => {
        if (listcnt.value === listData.value.data.length) {
          clearInterval(int);
          loaded.value = true;
          pdfImages.value = document.getElementsByClassName("pdf-img-n");
          pageImages.value = document.getElementsByClassName(
            "referans-img-tmp"
          );
        }
      }, 200);

      var imagesInt = setInterval(() => {
        if (pageImages.value.length > 0 || pdfImages.value.length === 0) {
          clearInterval(imagesInt);
          referenceImagesLoaded();
        }
      }, 200);

      var intimg = setInterval(() => {
        if (
          (loaded.value === true && pdfImages.value.length > 0) ||
          (loaded.value === true && noReference.value === true)
        ) {
          pdfImages.value.forEach(img => {
            if (img.complete) {
              imgcnt = imgcnt + 1;
            }
          });
        }
      }, 200);
      var intimgload = setInterval(() => {
        if (
          (pdfImages.value.length > 0 && imgcnt >= pdfImages.value.length) ||
          noReference.value === true
        ) {
          clearInterval(intimg);
          clearInterval(intimgload);
          isLoading.value = false;
        }
      }, 200);
    };
    const WindowResized = e => {
      contentEl.value.style.minHeight = e.target.innerHeight - 126 + "px";
    };
    onMounted(async () => {
      // PDF renklerini API'den yükle
      try {
        await getPdfColors();
        console.log("[PDF_EXPORT] PDF renkleri yüklendi");
      } catch (error) {
        console.error("[PDF_EXPORT] PDF renkleri yüklenirken hata:", error);
      }

      await store.dispatch("getWorkFolder");
      notesCatsList.value = await getNoteCatsList();
      // Tüm alt kategorileri al (pid=0) ve questPart değerine göre filtrele
      const initialQuestPart = questPart.value || 1;
      const branchResult = await getCatList(0);
      if (
        branchResult &&
        branchResult.data &&
        Array.isArray(branchResult.data)
      ) {
        // JavaScript'te filtrele: 1=Temel Bilimler (ParentId=1), 2=Klinik Bilimler (ParentId=2)
        const filteredData = branchResult.data.filter(item => {
          // Hem parentId hem ParentId kontrolü yap (camelCase ve PascalCase)
          const parentId =
            item.parentId !== undefined ? item.parentId : item.ParentId;
          if (initialQuestPart === 1) {
            // Temel Bilimler
            return parentId === 1;
          } else if (initialQuestPart === 2) {
            // Klinik Bilimler
            return parentId === 2;
          }
          return false;
        });
        branchList.value = { data: filteredData };
        branchId.value = null; // Seçimi kullanıcıya bırak
        subCategoryId.value = null; // Alt kategoriyi sıfırla
        subCategoryList.value = { data: [] }; // Alt kategori listesini temizle
      } else {
        branchList.value = { data: [] };
        branchId.value = null;
        subCategoryId.value = null;
        subCategoryList.value = { data: [] };
      }
      if (store.state.usertype === 2) {
        catList.value = await getCatList();
        catId.value = catList.value.data?.[0]?.id;
      }
      // Sayfa ilk açılırken startQuestion ve endQuestion değerlerini ayarla
      SetQuestionValue();
      contentEl.value = document.getElementById("content-C");
      contentEl.value.style.minHeight = window.innerHeight - 126 + "px";
      window.addEventListener("resize", WindowResized);
    });
    return {
      store,
      listData,
      loaded,
      newList,
      createPDF,
      createPDFSequential,
      createSeperatePDF,
      createPartPDF,
      realList,
      firstList,
      imagesList,
      questionType,
      makeUrl,
      realUrl,
      copyHtml,
      isCreating,
      isLoading,
      questPart,
      questParts,
      onExportFilter,
      onDynamicPropertyChange,
      clearDynamicFilters,
      filterBarRef,
      getQuests,
      pageImagesLoaded,
      startQuestion,
      endQuestion,
      errorImages,
      imagesLoaded,
      GetCategoryQuestions,
      catId,
      catList,
      branchId,
      branchList,
      subCategoryId,
      subCategoryList,
      onBranchChange,
      DownloadPdfUrl,
      applyFilter,
      notesCatsList,
      noteCategoryId,
      noteList,
      noteId,
      onNoteCategoryChange,
      getPdfColor,
      openPdfColorSettings
    };
  }
};
</script>
<style>
.export-question-C {
  width: 100%;
}
.all-reference-pages {
  position: fixed;
  opacity: 0;
  left: 100%;
  top: 0;
}
.txt-error {
  background-color: crimson;
  color: #fff;
  padding: 16px;
  border-radius: 4px;
}
</style>
